import request from '@/api/request'
import { AxiosRequestConfig } from 'axios'
import type {
  ResWithMeta,
  InfluencerListRes,
  InfluencerListReq,
  Res,
  InfluencerFiltersRes,
  InfluencersSitemapRes,
  IProductsCategoryDistributionRes
} from '@/types/api'

export const getInfluencerListApi = (params: InfluencerListReq, config?: AxiosRequestConfig) => {
  return request.get<ResWithMeta<InfluencerListRes>>(`/data/influencers`, { params, ...config })
}

export const getInfluencerFilterApi = (config?: AxiosRequestConfig) => {
  return request.get<Res<InfluencerFiltersRes>>(`/data/influencers/filters`, config)
}

// 获取达人
export const getInfluencersSitemapApi = async (
  params: { influencer_categories?: string; page?: string },
  config?: AxiosRequestConfig
) => {
  return request.get<Res<InfluencersSitemapRes>>(`/data/influencers/sitemap/list`, { params, ...config })
}

export const getBatchInfluencerApi = (
  data: { unique_ids: string[]; page?: number; per_page?: number },
  config?: AxiosRequestConfig
) => {
  return request.post<ResWithMeta<InfluencerListRes>>(`/data/influencers/batches`, { ...data, ...config })
}

export const getInfluencerDetailFilterApi = (id: string, config?: AxiosRequestConfig) => {
  return request.get<Res<InfluencerFiltersRes>>(`/data/influencers/${id}/products/filters`, config)
}

export const getInfluencerProductAnalysisApi = (id: string, config?: AxiosRequestConfig) => {
  return request.get<Res<IProductsCategoryDistributionRes>>(`/data/influencers/${id}/products/analysis`, config)
}
